import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NumberFormatter from "../../../_helpers/numberFormatter";
import { formatNameToInitials } from "../../../_helpers/stringNameChanger";
import { CopyIcon } from "../../../styles/img/svg/CopyIcon";
import { UiButton } from "../common/UiButton";
import { commonConstants } from "../../../_redux/_constants";

export const PawningAccountDetailCard = ({ accountDetail }) => {
  const { t } = useTranslation();
  const [details, setDetails] = useState({});
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (accountDetail) {
      setDetails({
        ...accountDetail,
        branchName: accountDetail.branchName?.replace("Branch", ""),
      });
    }
  }, [accountDetail]);

  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 5000);
      });
    }
  };

  return (
    <div className="df-account-detail-card">
      <div className="df-account-detail-card__gray">
        <div className="df-flex-itm">
          <div className="df-flex-itm__left">
            <div className="d-flex lc-icon-container">
              <h2>{details?.accountNumber}</h2>

              <div
                className="df-copy-icon-wrapper"
                onClick={() => {
                  const lines = [
                    `Account Name: ${details?.customerNameFinacleCore ?? ""}`,
                    `Account Number: ${details?.accountNumber ?? ""}`,
                    `Bank Name: ${
                      details?.bankName ? `${details.bankName} Bank` : ""
                    }`,
                    `Branch Name: ${[
                      details?.branchName,
                      details?.branchUnitCode,
                    ]
                      .filter(Boolean)
                      .join(" - ")}`,
                  ];

                  const fullText = lines.join("\n");
                  copyToClipboard(fullText);
                }}
              >
                <CopyIcon />
                {copied && (
                  <span className="df-copied-message">{` Copied!`}</span>
                )}
              </div>
            </div>

            <p className="df-acc-dc-acc-name">
              {details?.productName} | {details?.branchName} -{" "}
              {details?.branchCode}
            </p>

            <p>{formatNameToInitials(details?.customerNameFinacleCore)}</p>
          </div>

          <div className="df-flex-itm__right">
            <UiButton
              name={details?.productStatus}
              className={
                details?.productStatus ===
                commonConstants.ACCOUNT_ACTIVE_PRODUCT_STATUS
                  ? "df-green-linked-btn df-acc-detail-text-btn"
                  : "df-red-linked-btn df-acc-detail-text-btn"
              }
            />
          </div>
        </div>
      </div>

      <div className="df-account-detail-card__white">
        <div className="df-flex-itm">
          <div className="df-flex-itm__left">
            <p>{t("Advance Amount")}:</p>
          </div>
          <div className="df-flex-itm__right">
            <p>
              <strong>
                {details?.advanceAmount &&
                  NumberFormatter(details.advanceAmount)}
              </strong>
            </p>
          </div>
        </div>

        <div className="df-flex-itm">
          <div className="df-flex-itm__left">
            <p>{t("Total Loan Amount")}:</p>
          </div>
          <div className="df-flex-itm__right">
            <p>
              {details?.totalLoanAmount &&
                NumberFormatter(details.totalLoanAmount)}
            </p>
          </div>
        </div>

        <div className="df-flex-itm">
          <div className="df-flex-itm__left">
            <p>{t("Total Outstanding Amount")}:</p>
          </div>
          <div className="df-flex-itm__right">
            <p>
              {details?.loanOutstandingBalance &&
                NumberFormatter(details.loanOutstandingBalance)}
            </p>
          </div>
        </div>

        <div className="df-flex-itm">
          <div className="df-flex-itm__left">
            <p>{t("Interest Rate")}:</p>
          </div>
          <div className="df-flex-itm__right">
            <p>
              <p>{details?.interestRate}%</p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
